import { render, staticRenderFns } from "./HeartSolid.vue?vue&type=template&id=20c399e1&"
import script from "./HeartSolid.vue?vue&type=script&lang=ts&"
export * from "./HeartSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports